/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tags_Manager_Error_Get_Sets_LogInputs */

const en_tags_manager_error_get_sets_log = /** @type {(inputs: Tags_Manager_Error_Get_Sets_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error getting tag sets:`)
};

const fr_tags_manager_error_get_sets_log = /** @type {(inputs: Tags_Manager_Error_Get_Sets_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erreur lors de la recuperation des ensembles de tags :`)
};

const de_tags_manager_error_get_sets_log = /** @type {(inputs: Tags_Manager_Error_Get_Sets_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehler beim Abrufen von Tag-Sets:`)
};

const it_tags_manager_error_get_sets_log = /** @type {(inputs: Tags_Manager_Error_Get_Sets_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Errore durante il recupero dei set di tag:`)
};

const ru_tags_manager_error_get_sets_log = /** @type {(inputs: Tags_Manager_Error_Get_Sets_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ошибка при получении наборов тегов:`)
};

const es_tags_manager_error_get_sets_log = /** @type {(inputs: Tags_Manager_Error_Get_Sets_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al obtener conjuntos de etiquetas:`)
};

const zh_cn2_tags_manager_error_get_sets_log = /** @type {(inputs: Tags_Manager_Error_Get_Sets_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`获取标签集时出错：`)
};

const ja_tags_manager_error_get_sets_log = /** @type {(inputs: Tags_Manager_Error_Get_Sets_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タグ セットの取得中にエラーが発生しました:`)
};

const hi_tags_manager_error_get_sets_log = /** @type {(inputs: Tags_Manager_Error_Get_Sets_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टैग सेट प्राप्त करने में त्रुटि:`)
};

const pt_pt2_tags_manager_error_get_sets_log = /** @type {(inputs: Tags_Manager_Error_Get_Sets_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erro ao obter conjuntos de tags:`)
};

/**
* | output |
* | --- |
* | "Error getting tag sets:" |
*
* @param {Tags_Manager_Error_Get_Sets_LogInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const tags_manager_error_get_sets_log = /** @type {((inputs?: Tags_Manager_Error_Get_Sets_LogInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_Manager_Error_Get_Sets_LogInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_tags_manager_error_get_sets_log(inputs)
	if (locale === "de") return de_tags_manager_error_get_sets_log(inputs)
	if (locale === "it") return it_tags_manager_error_get_sets_log(inputs)
	if (locale === "ru") return ru_tags_manager_error_get_sets_log(inputs)
	if (locale === "es") return es_tags_manager_error_get_sets_log(inputs)
	if (locale === "zh-CN") return zh_cn2_tags_manager_error_get_sets_log(inputs)
	if (locale === "ja") return ja_tags_manager_error_get_sets_log(inputs)
	if (locale === "hi") return hi_tags_manager_error_get_sets_log(inputs)
	if (locale === "pt-PT") return pt_pt2_tags_manager_error_get_sets_log(inputs)
	return en_tags_manager_error_get_sets_log(inputs)
});